/**
 * @module dispatch
 * @description 事件分发
 * @param {Object.<string, function>} handlers - 事件处理函数组成的对象
 * @return {function} 分发函数
 * @example  <caption>事件代理利用e.target.dataset.trigger查找handlers中匹配处理函数</caption>
 * <ul class="anchor-list">
 *   <li><a href="#linkA" data-trigger="link" data-value="A">Link A</a></li>
 *   <li><a href="#linkB" data-trigger="link" data-value="B">Link B</a></li>
 *   <li><a href="#linkC" data-trigger="link" data-value="C">Link C</a></li>
 * </ul>
 * @example
 * const createClickHandlers = () => {
 *   const link = (e) => {
 *     const { value } = e.target.dataset;
 *
 *     alert(value);
 *   };
 *
 *   return {
 *     link,
 *   };
 * };
 *
 * const clickHandlers = createClickHandlers();
 * document.body.addEventListener('click', dispatch(clickHandlers), false);
 */

export default handlers => (e) => {
  const { trigger } = e.target.dataset;

  if (trigger && {}.hasOwnProperty.call(handlers, trigger)) {
    handlers[trigger](e);
  }
};
